import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/pro-regular-svg-icons';
import Button from 'components/Sdk/Button';

import 'components/Sdk/Button/Button.scss';

const formatMomentToString = (momentObj, setObj) =>
  momentObj && momentObj.set(setObj).format('YYYY-MM-DDTHH:mm:ss');

const DayFilterPicker = ({ filters, updateFilters }) => {
  const [focusedInput, setFocusedInput] = useState(null);

  const onDatesChange = ({ startDate, endDate }) => {
    const startDateString = formatMomentToString(startDate, {
      hour: 0,
      minute: 0,
      second: 0,
    });
    const endDateString = formatMomentToString(endDate, {
      hour: 23,
      minute: 59,
      second: 59,
    });
    if (focusedInput === 'startDate') {
      updateFilters({ startDate: startDateString, endDate: null });
    } else if (
      startDateString !== filters.startDate ||
      endDateString !== filters.endDate
    ) {
      updateFilters({ startDate: startDateString, endDate: endDateString });
    }
  };

  const onFocusChange = focus => {
    setFocusedInput(focus);
  };

  const renderDatePresets = () => {
    const today = moment();
    const presets = [
      {
        text: 'Past Month',
        start: today.clone().subtract(1, 'months'),
        end: today,
      },
      {
        text: 'Past Week',
        start: today.clone().subtract(1, 'weeks'),
        end: today,
      },
      {
        text: 'Past Day',
        start: today.clone().subtract(1, 'days'),
        end: today,
      },
    ];

    const onClick = (startDate, endDate) => {
      const startDateString = formatMomentToString(startDate, {
        hour: 0,
        minute: 0,
        second: 0,
      });
      const endDateString = formatMomentToString(endDate, {
        hour: 23,
        minute: 59,
        second: 59,
      });
      updateFilters({ startDate: startDateString, endDate: endDateString });
    };

    return (
      <div className="p-3">
        {presets.map(({ text, start, end }) => {
          const isSelected =
            filters.startDate ===
              formatMomentToString(start, {
                hour: 0,
                minute: 0,
                second: 0,
              }) &&
            filters.endDate ===
              formatMomentToString(end, {
                hour: 23,
                minute: 59,
                second: 59,
              });
          return (
            <Button
              active={isSelected}
              color="info"
              key={text}
              onClick={() => onClick(start, end)}
              outline
              size="sm"
              type="button"
            >
              {text}
            </Button>
          );
        })}
      </div>
    );
  };

  const startDate = filters.startDate ? moment(filters.startDate) : null;
  const endDate = filters.endDate ? moment(filters.endDate) : null;

  return (
    <DateRangePicker
      customInputIcon={<FontAwesomeIcon icon={faCalendarAlt} />}
      daySize={40}
      enableOutsideDays
      endDate={endDate} // momentPropTypes.momentObj or null,
      endDateId="filterEndDate"
      firstDayOfWeek={1}
      focusedInput={focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
      hideKeyboardShortcutsPanel
      horizontalMonthPadding={0}
      isOutsideRange={() => false} // allow past dates to be selected
      minimumNights={0}
      noBorder
      numberOfMonths={1}
      onDatesChange={onDatesChange} // PropTypes.func.isRequired,
      onFocusChange={onFocusChange} // PropTypes.func.isRequired,
      renderCalendarInfo={renderDatePresets}
      startDate={startDate} // momentPropTypes.momentObj or null,
      startDateId="filterStartDate"
      showClearDates
      transitionDuration={0}
      verticalHeight={260}
    />
  );
};

DayFilterPicker.propTypes = {
  filters: PropTypes.shape({
    endDate: PropTypes.string,
    startDate: PropTypes.string,
  }),
  updateFilters: PropTypes.func.isRequired,
};

DayFilterPicker.defaultProps = {
  filters: {},
};

export default DayFilterPicker;
